import z from "zod";

export const signUpSchema = z
  .object({
    firstName: z.string().min(1, "First name is required").max(32, "First name is too long, it must not exceed 32 characters"),

    lastName: z.string().min(1, "Last name is required").max(32, "Last name is too long, it must not exceed 32 characters"),

    emailAddress: z.email({ message: "Email address is not a valid email" }).min(1, "Email address is required").max(256, "Email address is too long, it must not exceed 256 characters"),

    password: z
      .string()
      .min(8, "Password is too short, it must be at least 8 characters")
      .max(64, "Password is too long, it must not exceed 64 characters")
      .regex(/[A-Z]/, "Password must include an uppercase letter")
      .regex(/[a-z]/, "Password must include a lowercase letter")
      .regex(/[0-9]/, "Password must include a number")
      .regex(/[^A-Za-z0-9]/, "Password must include a special character"),

    confirmPassword: z.string().min(1, "Confirm password is required"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export const loginSchema = z.object({
  emailAddress: z.email({ message: "Email address is not a valid email" }).max(256, "Email address is too long, it must not exceed 256 characters"),

  password: z.string().min(1, "Password is required"),
});

export type SignUpSchema = z.infer<typeof signUpSchema>;
export type LoginSchema = z.infer<typeof loginSchema>;
